import React from 'react';

import './Contact.css';

const Contact = () => {
    return (
        <div>
            <div className="title">Contact Us</div>
            <div>Please use the <code>Share</code> tab in the app to send us feedback, or, email us directly by clicking <a href="mailto:feedback@squawkstudio.com">here</a>.</div>
        </div>
    );
};

export default Contact;